import gql from 'graphql-tag'

export const AUTH_LOGIN = gql`
  mutation auth($email: String!, $password: String!, $keepAlive: String) {
    auth(email: $email, password: $password, keepAlive: $keepAlive) {
      token
    }
  }
`

export const AUTH_GOOGLE = gql`
  mutation authGoogle($idToken: String!) {
    authGoogle(idToken: $idToken) {
      token
    }
  }
`

export const AUTH_FACEBOOK = gql`
  mutation authFacebook($accessToken: String!) {
    authFacebook(accessToken: $accessToken) {
      token
    }
  }
`

export const AUTHORIZE_SSO = gql`
  mutation authorizeSSO($clientId: String!, $redirectUri: String!, $responseType: String, $state: String) {
    authorizeSSO(clientId: $clientId, redirectUri: $redirectUri, responseType: $responseType, state: $state) {
      code
      state
      auto_authorized
      requires_authorization
    }
  }
`
